/**
 * "Integration models" — the first thing to read: which of the three ways to
 * put packs in front of players you are on, and what each one asks of you.
 * Every later recipe says which model it applies to. Partner-facing markdown.
 */
export const integrationModels: string[] = [
  '## Integration models',
  '',
  'There are three ways to put packs in front of your players. Pick one — the rest of this page marks',
  'what applies to which.',
  '',
  '| Model | Player UI | What you implement |',
  '| --- | --- | --- |',
  '| **Hosted player experience** *(most partners)* | Ours — the player iframe, themed from this console | The **wallet callbacks** and **Create session** on your backend. In the browser: embed the iframe with the `session_token` and, optionally, listen to its events. |',
  '| **Custom UI** | Yours, built on the **Player API** | The same callbacks and Create session, plus every screen — catalog, purchase, reveal, sell, inventory (deliveries optional). |',
  '| **Embed mode** | Ours | Nothing server-side: we fund players by card and register them inside the iframe. See *Embed mode* below. |',
  '',
  'The money flow is identical in the first two: the hosted iframe calls the same Player API on the',
  'player’s behalf, and your wallet sees the same `debit` / `credit` / `refund` callbacks either way.',
  '',
];
